import { render, staticRenderFns } from "./ModifySuc.vue?vue&type=template&id=0a1d64e0&"
import script from "./ModifySuc.vue?vue&type=script&lang=js&"
export * from "./ModifySuc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports